export default __webpack_public_path__ + "static/media/cart_purchase.d1d1ee9f.jpg";